module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("THE")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/tp_everuthing.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "line-height": "2em"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "big2"
  }, [_vm._v("PARENT’S GUIDE TO")]), _c('br'), _c('span', {
    staticClass: "big3"
  }, [_vm._v("EATING"), _c('br'), _vm._v("DISORDERS")])]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "big4"
  }, [_vm._v("The information you need to see the warning signs, help promote positive body image, and develop a recovery plan for your child")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "big4"
  }, [_vm._v("Angie Best-Boss, MA")]), _c('br'), _vm._v("Content Editor, "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "http://EatingDisordersOnline.com",
      "target": "_blank"
    }
  }, [_vm._v("EatingDisordersOnline.com")]), _c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/logo.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2e9b09e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/tp.vue
// module id = 69
// module chunks = 0